import { createUseStyles } from '../../theme/theming';

const useFaqListStyles = createUseStyles((theme) => ({
  section: {
    width: '100%',
    padding: ({ isMobile } = {}) =>
      isMobile
        ? `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
        : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
    backgroundColor: theme?.colors?.background2,

    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    },
    '& h2,& h3': {
      marginTop: '0'
    }
  },
  sectionContainer: {
    maxWidth: ({ containerWidth } = {}) => containerWidth
  },

  sectionSubheading: {
    color: theme?.colors?.font3,
    fontSize: theme.typography.fontSize.subHead,
    marginBottom: '8px',
    wordBreak: 'break-word'
  },
  sectionHeading: {
    fontSize: theme.typography.fontSize.h2,
    fontWeight: theme.typography.fontWeight.bold,
    wordBreak: 'break-word',
    marginBottom: `${theme.spacing.margin.tiny}px`,
    color: theme?.colors?.font3
  },
  container: {
    boxShadow: theme?.shadows?.secondary,
    borderRadius: '8px',
    backgroundColor: theme?.colors?.white
  },
  basicCardContainer: {
    borderBottom: `1px solid #D8E0F0`,
    padding: `${theme.spacing.padding.tiny}px`
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: ({ isSelected } = {}) => (isSelected ? '16px' : '0')
  },
  arrowButton: {
    marginLeft: theme.spacing.margin.tiny
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  title: {
    color: theme?.colors?.lightblack,
    fontSize: theme.typography.fontSize.h5,
    fontWeight: theme.typography.fontWeight.bold,
    margin: '0',
    wordBreak: 'break-word'
  },

  content: {
    color: theme?.colors?.lightblack,
    fontSize: theme.typography.fontSize.body,
    lineHeight: '24px',
    maxHeight: ({ isSelected } = {}) => (isSelected ? 'unset' : '0'),
    transition: 'all 0.7s',
    overflow: 'hidden'
  },

  '@media screen and (max-width: 767px)': {
    sectionSubheading: {
      textAlign: 'center'
    },
    sectionHeading: {
      textAlign: 'center'
    },
    title: {
      fontSize: '14px',
      lineHeight: '22px'
    },
    content: {
      fontSize: '14px',
      lineHeight: '22px'
    },
    basicCardContainer: {
      '&:last-child': {
        borderBottom: 'none'
      }
    }
  }
}));
export default useFaqListStyles;
